import { resolutionHeader } from 'src/Tenants';
import './LLMContainer.scss';

export const LLMContainer = () => {
  const authToken = JSON.parse(localStorage.getItem('auth'));
  const tenantId = resolutionHeader;

  var env = import.meta.env.VITE_ENVIRONMENT;

  const VITE_JUNIPER_LLM_STAGING_URL = 'https://staging-juniper.glimpse.re';
  const VITE_JUNIPER_LLM_PROD_URL = 'https://juniper.glimpse.re';

  const baseUrl = ['dev', 'staging'].includes(env)
    ? VITE_JUNIPER_LLM_STAGING_URL
    : VITE_JUNIPER_LLM_PROD_URL;

  return (
    <iframe
      src={`${baseUrl}?authToken=${authToken}&tenantId=${tenantId}`}
      width="100%"
      height="500"
      loading="lazy"
      className="llm-frame"
      frameBorder={'0'}
    />
  );
};
